import React, { useState } from 'react';
import styles from './Input.module.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ReactComponent as ShowPassword } from '../../images/ShowPassword.svg';
import { ReactComponent as HidePassword } from '../../images/HidePassword.svg';

const Input = ({ label, id, register, errors, type, secondLabel: SecondLabel, infoLabel: InfoLabel, ...props }) => {
    const [showPass, setShowPass] = useState(false);
    return (
        <div className={styles['container']}>
            <label
                className={classNames(styles.label, {
                    [styles['label--flex']]: SecondLabel
                })}
                htmlFor={id}
            >
                {label}
                {SecondLabel && <SecondLabel />}
            </label>
            <div className={styles['input__container']}>
                <input
                    id={id}
                    ref={register}
                    className={classNames(styles.input, {
                        [styles['input--error']]: errors
                    })}
                    type={type !== 'password' ? type : showPass ? 'text' : 'password'}
                    {...props}
                />
                {type === 'password' && (
                    <span
                        onClick={() => {
                            setShowPass((prevState) => !prevState);
                        }}
                        className={styles['input__visibility']}
                    >
                        {showPass ? <ShowPassword /> : <HidePassword />}
                    </span>
                )}
            </div>
            {errors?.message?.length > 0 && <span className={styles.errors}>{errors.message}</span>}
            {InfoLabel && (
                <div className={styles.info_label}>
                    <InfoLabel />
                </div>
            )}
        </div>
    );
};

export default Input;

Input.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    register: PropTypes.func,
    errors: PropTypes.object,
    type: PropTypes.string,
    secondLabel: PropTypes.func,
    infoLabel: PropTypes.func
};
